// This file is auto-generated by scripts/generate-enum-values.ts

export const BOOKING_ENGINE_TYPES = [
  'MARRIOTT',
  'IHG',
  'HILTON',
  'HYATT',
  'CHOICE',
  'WYNDHAM',
  'ACCOR',
  'MOTEL6',
  'BEST_WESTERN',
  'SONESTA',
  'SYNXIS',
  'TRAVELCLICK',
  'IHOTELIER',
  'PEGASUS',
  'WINDSURFER',
  'SITEMINDER',
  'CLOUDBEDS',
  'MEWS',
  'EXPEDIA',
  'BOOKING',
  'AGODA',
  'TRIP',
] as const;
export type BookingEngineType = (typeof BOOKING_ENGINE_TYPES)[number];

export const HOTEL_SITES = [
  'AI',
  'PLACE',
  'OSM',
  'EXPEDIA',
  'SMART_SCRAPERS',
] as const;
export type HotelSite = (typeof HOTEL_SITES)[number];

export const BOOKING_SITES = [
  'BRAND',
  'EXPEDIA',
  'BOOKING',
  'AGODA',
  'TRIP',
] as const;
export type BookingSite = (typeof BOOKING_SITES)[number];

export const RATE_PLAN_CATEGORIES = [
  'BAR',
  'RACK',
  'WITH_BREAKFAST',
  'NON_REFUNDABLE',
  'CORPORATE',
  'PROMOTIONAL',
  'LOYALTY',
  'EARLY_BOOKING',
  'LAST_MINUTE',
  'UNKNOWN',
] as const;
export type RatePlanCategory = (typeof RATE_PLAN_CATEGORIES)[number];

export const ROOM_TYPE_CATEGORIES = [
  'STANDARD',
  'SUPERIOR',
  'DELUXE',
  'JUNIOR_SUITE',
  'SUITE',
  'EXECUTIVE_SUITE',
  'UNKNOWN',
] as const;
export type RoomTypeCategory = (typeof ROOM_TYPE_CATEGORIES)[number];

export const HOTEL_SETTINGS_OPTIONS = [
  'BOOTSTRAP_LEARNING',
  'SETS_LEARNING',
  'SHOPPING',
  'COMP_SET_MEMBER',
] as const;
export type HotelSettingsOption = (typeof HOTEL_SETTINGS_OPTIONS)[number];

export const LOCATION_OPTIONS = [
  'MARKET_ENABLED',
  'DISALLOW_CITIES',
  'OSMOSIS_ENABLED',
  'IGNORE_OSMOSIS_STATES',
  'DUPLICATE_NAME',
] as const;
export type LocationOption = (typeof LOCATION_OPTIONS)[number];

export const ANALYTICS_REPORT_TYPES = [
  'RATE_COUNT',
  'RATE',
  'RATE_DETAIL',
  'RATE_AS_OF',
  'RATE_ANY',
  'COUNTRY',
  'COUNTRY_HOTELS',
  'CONTINENT_HOTELS',
  'STATE',
  'STATE_HOTELS',
  'CITY',
  'CITY_HOTELS',
  'CITY_TO_COUNTRY',
  'CITY_NAME_NORM_MERGE',
  'MARKET',
  'MARKET_CHILD',
  'PLACE',
  'PLACE_TYPE',
  'COMP_SET',
  'COMP_SET_DANGLING',
  'COMP_SET_SHOPPING_EXTRA',
  'COMPANY',
  'COMPANY_CHILD',
  'COMPANY_NO_TIER',
  'COMPANY_MERGED_USAGE',
  'COMPANY_NAME_NORM_MERGE',
  'COMPANY_HOTEL_STATS',
  'HOTEL_SHOPPED',
  'HOTEL_BOOTSTRAP',
  'HOTEL_PLACE_NOT_OSM',
  'HOTEL_OSM_NOT_PLACE',
  'HOTEL_ISSUES',
  'HOTEL_ADDRESS_OSM_TO_PLACE',
  'HOTEL_NAME_NORM_MERGE',
  'HOTEL_HOST_BRAND_MISMATCH',
  'HOTEL_HOST_BRAND_MISMATCH_DETAILS',
  'HOTEL_HOME_PAGE',
  'HOTEL_HOME_PAGE_NO_COMPANY',
  'HOTEL_TECH_COMPANY',
  'HOTEL_TECH_COMPANY_STATS',
  'HOTEL_BRAND_PARENT',
  'HOTEL_BRAND_PARENT_STATS',
  'HOTEL_BOOKING_ENGINE',
  'SHARED_RATE_SCRAPE_METADATA',
  'RATE_SCRAPE_METADATA',
  'RATE_SCRAPE_METADATA_BOOTSTRAP_INCOMPLETE',
  'RATE_SCRAPE_METADATA_DANGLING',
  'RATE_SCRAPE_METADATA_EXTRA',
  'RATE_SCRAPE_METADATA_ISSUES',
  'RATE_SCRAPE_METADATA_WRONG_BE',
  'SELECTOR_SETS',
  'INDICATOR_SETS',
  'HOTEL_METADATA',
  'HOTEL_METADATA_BOOTSTRAP_INCOMPLETE',
  'HOTEL_METADATA_DANGLING',
  'RATE_PLANS',
  'ROOM_TYPES',
] as const;
export type AnalyticsReportType = (typeof ANALYTICS_REPORT_TYPES)[number];

export const ANALYTICS_HOTEL_REPORT_TYPES = [
  'CHART',
  'CURVE',
  'COMP',
] as const;
export type AnalyticsHotelReportType = (typeof ANALYTICS_HOTEL_REPORT_TYPES)[number];

export const RATE_SCRAPE_METADATA_FIELDS_TO_CLEAR = [
  'urlTemplate',
  'dateFormat',
  'localHotelId',
  'botDetectionType',
  'sourceBookingEngine',
  'learnExtra',
  'selectors',
  'indicators',
] as const;
export type RateScrapeMetadataFieldToClear = (typeof RATE_SCRAPE_METADATA_FIELDS_TO_CLEAR)[number];

export const LAMBDA_SIZES = [
  'NORMAL',
  'MEDIUM',
  'LARGE',
] as const;
export type LambdaSize = (typeof LAMBDA_SIZES)[number];

export const DATE_PARAM_OPTIONS = [
  'ZERO_BASED_MONTH',
] as const;
export type DateParamOption = (typeof DATE_PARAM_OPTIONS)[number];

export const DATE_PARAM_TYPES = [
  'ARRIVAL',
  'DEPARTURE',
  'LOS',
] as const;
export type DateParamType = (typeof DATE_PARAM_TYPES)[number];

const bookingEngineTypeSet = new Set<string>(BOOKING_ENGINE_TYPES as readonly string[]);
const hotelSiteSet = new Set<string>(HOTEL_SITES as readonly string[]);
const bookingSiteSet = new Set<string>(BOOKING_SITES as readonly string[]);
const hotelSettingsOptionSet = new Set<string>(HOTEL_SETTINGS_OPTIONS as readonly string[]);
const locationOptionSet = new Set<string>(LOCATION_OPTIONS as readonly string[]);
const analyticsReportTypeSet = new Set<string>(ANALYTICS_REPORT_TYPES as readonly string[]);
const analyticsHotelReportTypeSet = new Set<string>(ANALYTICS_HOTEL_REPORT_TYPES as readonly string[]);
const rateScrapeMetadataFieldToClearSet = new Set<string>(RATE_SCRAPE_METADATA_FIELDS_TO_CLEAR as readonly string[]);
const lambdaSizeSet = new Set<string>(LAMBDA_SIZES as readonly string[]);
const dateParamOptionSet = new Set<string>(DATE_PARAM_OPTIONS as readonly string[]);
const dateParamTypeSet = new Set<string>(DATE_PARAM_TYPES as readonly string[]);

export function isBookingEngineType(value: string): value is BookingEngineType {
  return bookingEngineTypeSet.has(value);
}

export function isHotelSite(value: string): value is HotelSite {
  return hotelSiteSet.has(value);
}

export function isBookingSite(value: string): value is BookingSite {
  return bookingSiteSet.has(value);
}

export function isHotelSettingsOption(value: string): value is HotelSettingsOption {
  return hotelSettingsOptionSet.has(value);
}

export function isLocationOption(value: string): value is LocationOption {
  return locationOptionSet.has(value);
}

export function isAnalyticsReportType(value: string): value is AnalyticsReportType {
  return analyticsReportTypeSet.has(value);
}

export function isAnalyticsHotelReportType(value: string): value is AnalyticsHotelReportType {
  return analyticsHotelReportTypeSet.has(value);
}

export function isRateScrapeMetadataFieldToClear(value: string): value is RateScrapeMetadataFieldToClear {
  return rateScrapeMetadataFieldToClearSet.has(value);
}

export function isLambdaSize(value: string): value is LambdaSize {
  return lambdaSizeSet.has(value);
}

export function isDateParamOption(value: string): value is DateParamOption {
  return dateParamOptionSet.has(value);
}

export function isDateParamType(value: string): value is DateParamType {
  return dateParamTypeSet.has(value);
}
